import { TeButton, TeText } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { PlaceholderContainer } from '@topcon/topcon-utils';

interface Props {
  onClick?: () => void;
}

function EmptyDivisions({ onClick }: Props) {
  const { t } = useTranslation('divisions');

  return (
    <PlaceholderContainer
      grow
      icon="business"
      text={t('noDivisions')}
      secondaryText={t('noDivisionsDescription')}
      backgroundColor="background.secondary"
    >
      <TeText size={12} weight={400} color="text.secondary">
        {onClick ? t('clickButtonToAddOne') : undefined}
      </TeText>
      {onClick && <TeButton text={t('createDivision')} size="s" teclick={onClick} />}
    </PlaceholderContainer>
  );
}

export default EmptyDivisions;
